import { useMemo } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { getPhoneDialCodePlaceholder } from '../utils/getPhoneDialCodePlaceholder'

export const usePhoneDialCodePlaceholder = (): string => {
  const { organization } = useUserOrganization()

  return useMemo(
    () => getPhoneDialCodePlaceholder(organization?.countryId, navigator.language),
    [organization?.countryId],
  )
}
